webpackJsonp([131065640628419],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/posts-2017-07-18-welcome.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"site": {
				"siteMetadata": {
					"title": "Nate A Taylor",
					"author": "Nate A Taylor"
				}
			},
			"markdownRemark": {
				"id": "/Users/ntaylor/Workspace/nate-site/src/pages/posts/07-18-2017---welcome.md absPath of file >>> MarkdownRemark",
				"html": "<p>Welcome to my site! My name is Nate. I’m a web developer living in Boise, ID.\nAt this blog, you can find me writing about Ruby, JavaScript, and other web stuff I find interesting.</p>\n<p>On occasion, I may write about some of my other interests, which include</p>\n<ul>\n<li>Music</li>\n<li>Video Games</li>\n<li>Beer</li>\n<li>Bikes</li>\n</ul>\n<p>If you have any comments, concerns, or criticisms, please feel free to <a href=\"mailto:nathantaylor89@gmail.com\">contact me</a></p>",
				"frontmatter": {
					"title": "Welcome",
					"summary": "An introduction to me.",
					"tags": [
						"random"
					],
					"date": "July 18, 2017"
				}
			}
		},
		"pathContext": {
			"slug": "/posts/2017/07/18/welcome/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---posts-2017-07-18-welcome-a538175254bc5ec86b39.js